export const isInteger = (value: any): value is number => typeof value === 'number' && Number.isInteger(value);

export const formatPercentage = (number?: number | null, decimals = 0, returnSign = false, fallback = 'N/A') => {
	if (number === undefined || number === null) return fallback;
	const formatted = number.toLocaleString(undefined, { style: 'percent', minimumFractionDigits: decimals, maximumFractionDigits: decimals });
	if (returnSign) {
		if (number > 0) {
			return '+' + formatted;
		}
	}
	return formatted;
};

// NOTE: turns 1500 into 1,500
export const formatLargeNumber = (number?: number | null, decimals = 0, fallback = 'N/A') => {
	if (number === undefined || number === null) return fallback;
	return number.toLocaleString(undefined, {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	});
};
